import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=1e4fdd0e&scoped=true"
import script from "./IncidentList.vue?vue&type=script&lang=js"
export * from "./IncidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fdd0e",
  null
  
)

export default component.exports